import * as React from 'react';
import { ECommuteDistanceType } from '../../../../../types/filters';
import { RangeInput } from '../../../../RangeInput';
import { RadioButtonGroup } from '../../../../RadioButtonGroup';
import * as styles from './DistanceRange.css';

type TDistanceType = {
  value: ECommuteDistanceType;
  label: string;
};

export interface IDistanceRangeProps {
  distanceTypes: TDistanceType[];
  selectedDistanceType?: ECommuteDistanceType;
  valueMin: number | undefined;
  valueMax: number | undefined;
  onChangeDistanceType(value: ECommuteDistanceType): void;
  onChangeDistance(min: number | undefined, max: number | undefined): void;
}

export const DistanceRange: React.VFC<IDistanceRangeProps> = ({
  distanceTypes,
  selectedDistanceType,
  onChangeDistanceType,
  valueMin,
  valueMax,
  onChangeDistance,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['types']}>
        <RadioButtonGroup options={distanceTypes} value={selectedDistanceType} onChange={onChangeDistanceType} />
      </div>
      {selectedDistanceType && (
        <div className={styles['distance']}>
          <RangeInput
            spliced={true}
            maxWidth={120}
            min={0}
            max={9999}
            valueMin={valueMin}
            valueMax={valueMax}
            onChange={onChangeDistance}
          />
          <span className={styles['units']}>км</span>
        </div>
      )}
    </div>
  );
};
